import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Carousel from 'nuka-carousel';

import Section from '../global/section';
import Top from '../top';

const StyledAwards = styled.div`
	section {
		text-align: center;
		.slider-container {
			width: 80%;
			margin: 2rem auto 0;
			.award {
				display: flex;
				justify-content: center;
				align-items: center;
				padding: 0 1rem;
			}

			.slider-control-centerright {
				right: -1rem !important;
				img {
					width: 1rem;
				}
			}
			.slider-control-centerleft {
				left: -1rem !important;
				img {
					width: 1rem;
				}
			}
		}
	}
`;

export default ({ data }) => {
	const { top, title, slider } = data;
	const [slides, setSlides] = useState(3);

	useEffect(() => {
		// hacky carousel fix
		setTimeout(() => window.dispatchEvent(new Event('resize')), 1000);

		const handleResize = () => {
			window.innerWidth < 768 ? setSlides(1) : setSlides(3);
		};
		handleResize();
		window.addEventListener('resize', handleResize);
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	});

	return (
		<StyledAwards>
			<Section bg="light">
				<Top color="red">{top}</Top>
				<h2>{title}</h2>
				<div className="slider-container">
					<Carousel
						renderCenterLeftControls={({ previousSlide }) => (
							<button aria-label="previous slide" onClick={previousSlide}>
								<img src="/img/chevron-left.svg" alt="chevron left" />
							</button>
						)}
						renderCenterRightControls={({ nextSlide }) => (
							<button aria-label="next slide" onClick={nextSlide}>
								<img src="/img/chevron-right.svg" alt="chevron right" />
							</button>
						)}
						renderBottomCenterControls={null}
						wrapAround={true}
						autoplay={true}
						slidesToShow={slides}
					>
						{/* Double length to fix flashing slide */}
						{slider.concat(slider).map((x, i) => (
							<div className="award" key={i}>
								<img src={x.img} alt={x.alt} />
							</div>
						))}
					</Carousel>
				</div>
			</Section>
		</StyledAwards>
	);
};
